export const DEFAULT_CATEGORY_STYLE_CONFIG = {
  gradient: 'darkSurfaceAccent',
} as const;

export const JACKPOT_CATEGORY_STYLE_CONFIG = {
  box: {
    variant: 'gradient',
    paddingTop: 'space-400',
    paddingBottom: 'space-300',
  },
  text: {
    gradient: undefined,
    color: 'accentSurfacePrimary',
  },
} as const;
